export const setLogin = payload => ({
  type: 'SET_USER_LOGIN',
  payload,
});
